import { PropsWithChildren } from 'react';

import styled from '@emotion/styled';

interface Props {
  tabHeight: number;
}

const TabContent = ({ tabHeight, children }: PropsWithChildren<Props>) => {
  return <Container tabHeight={tabHeight}>{children}</Container>;
};

const Container = styled.div<{ tabHeight: number }>`
  display: flex;
  flex-direction: column;
  scroll-margin-top: ${({ tabHeight }) => tabHeight}px;
`;

export default TabContent;
